import React from "react";
import { isString } from "lodash";
import { Dropdown } from "semantic-ui-react";

import { formatStampRange } from "../../common/helpers";
import { history } from "../../store";

export const StampRollSelectorComponent = ({
    rolls,
    onSelect,
    canAddNewRoll = true,
    dropdownProps = {},
}) => {
    const options = rolls.map((roll, rollIndex) => ({
        icon: "ticket",
        value: rollIndex,
        key: `stamp_roll_${roll.roll_id}_${roll.firstAvailable}_${roll.lastAvailable}`,
        "data-cy": `roll_option_${rollIndex}`,
        text: formatStampRange({
            prefix: roll.prefix,
            from: roll.firstAvailable,
            to: roll.lastAvailable,
        }),
    }));

    if (canAddNewRoll) {
        options.push({
            key: `stamp_roll_create_link`,
            value: "/stamp/roll",
            text: "Add New Roll",
            icon: "plus",
            "data-cy": "roll_option_add_new",
        });
    }

    return (
        <Dropdown
            onChange={(_, data) => {
                if (isString(data.value) && data.value.indexOf("/") >= 0) history.push(data.value);
                else onSelect(data.value);
            }}
            selectOnBlur={false}
            text="Change Roll"
            options={options}
            floating
            button
            data-cy="stamp_roll_selector"
            {...dropdownProps}
        />
    );
};
